import type { DoorOperationType } from "building-types/doors/doorOperationTypes";

/**
 * @NOTE currently all door operation types may have casing
 */
export function doorOperationHasCasing(_: DoorOperationType): boolean {
  // return type !== DoorOperationType.OPEN;
  return true;
}
